import React, { useCallback } from 'react';
import { Box, Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';

export default function CodeBlockWithCopy({ code, language, theme }) {
    const [copied, setCopied] = React.useState(false);
    const handleCopy = useCallback(() => {
      navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    }, [code]);
    return (
      <Box sx={{ position: 'relative', mb: 1, backgroundColor: 'black' }}>
        <Button
          onClick={handleCopy}
          size="small"
          variant="outlined"
          startIcon={copied ? <CheckIcon /> : <ContentCopyIcon />}
          sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2, minWidth: 0, px: 1, py: 0.5, fontSize: 13 }}
        >
          {copied ? 'Copied!' : 'Copy this'}
        </Button>
        <SyntaxHighlighter
          language={language}
          style={theme}
          showLineNumbers={false}
          wrapLines={false}
          wrapLongLines={true}
          customStyle={{
            background: 'inherit',
            overflowX: 'auto',
            margin: 0,
            borderRadius: 8,
            fontSize: 15,
            paddingTop: 36,
          }}
        >
          {code}
        </SyntaxHighlighter>
      </Box>
    );
  }
  